import { useEffect, useRef, useState } from 'react';

const features = [
  {
    icon: 'ri-shield-check-line',
    color: 'text-azul-medio',
    bg: 'bg-azul-claro/10',
    title: 'Ambiente Seguro e Familiar',
    desc: 'Estrutura pensada para o bem-estar das crianças, com monitoramento, portão eletrônico e profissionais treinados.',
  },
  {
    icon: 'ri-heart-3-line',
    color: 'text-vermelho',
    bg: 'bg-vermelho/10',
    title: 'Princípios Cristãos',
    desc: 'Educação que forma não só a mente, mas também o caráter e os valores morais das crianças.',
  },
  {
    icon: 'ri-plant-line',
    color: 'text-azul-escuro',
    bg: 'bg-azul-escuro/10',
    title: 'Desenvolvimento Integral',
    desc: 'Cuidamos do crescimento emocional, social, cognitivo e físico de cada criança individualmente.',
  },
  {
    icon: 'ri-user-heart-line',
    color: 'text-azul-medio',
    bg: 'bg-azul-claro/10',
    title: 'Equipe Atenciosa',
    desc: 'Profissionais apaixonados pela educação infantil, dedicados a acolher cada criança com amor e paciência.',
  },
];

export default function SobreEscola() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="sobre" className="py-24 bg-white" ref={ref}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image side */}
          <div
            className={`transition-all duration-700 ${visible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}
          >
            <div className="relative rounded-3xl overflow-hidden h-[480px] w-full">
              <img
                src="https://storage.readdy-site.link/project_files/f6b15bb9-0a9f-496b-9ad9-42176d58e2ec/4b0e94d4-db8b-4749-842a-72c0e61ca314_20251110_093658.jpg?v=bd82721ad4db1ce7a36769ba0072d349"
                alt="Professora carinhosa com crianças da escola infantil em Campinas"
                title="Escola Infantil Turminha da Alegria – educação infantil em Campinas"
                className="w-full h-full object-cover object-center"
              />
              {/* Decoration dot */}
              <div className="absolute -top-4 -right-4 w-20 h-20 rounded-full bg-azul-claro/30" />
            </div>
          </div>

          {/* Text side */}
          <div
            className={`transition-all duration-700 delay-200 ${visible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}
          >
            <span className="inline-block bg-vermelho/10 text-vermelho font-body font-700 text-sm px-4 py-1.5 rounded-full mb-4">
              Quem Somos
            </span>
            <h4 id="sobre-escola">
              <a className="font-heading text-[#0D0D0D] text-3xl lg:text-4xl leading-tight block mb-6">
                Uma escola que <span className="text-azul-medio">cuida</span> e<br />
                <span className="text-vermelho">inspira</span> seu filho
              </a>
            </h4>
            <p className="font-body text-gray-600 text-base leading-relaxed mb-8">
              Na <strong>Turminha da Alegria</strong>, acreditamos que os primeiros anos de vida são fundamentais 
              para o desenvolvimento humano. Nossa escola infantil em Campinas oferece um ambiente acolhedor, 
              seguro e cheio de alegria, onde cada criança é tratada com amor e atenção individualizada.
            </p>

            <div className="grid sm:grid-cols-2 gap-4">
              {features.map((item) => (
                <div
                  key={item.title}
                  className="flex items-start gap-3 p-4 rounded-2xl bg-cinza hover:bg-white hover:shadow-sm transition-all duration-200"
                >
                  <div className={`w-10 h-10 flex items-center justify-center ${item.bg} rounded-xl flex-shrink-0`}>
                    <i className={`${item.icon} ${item.color} text-xl`} />
                  </div>
                  <div>
                    <h5 className="font-body font-700 text-[#0D0D0D] text-sm mb-1">{item.title}</h5>
                    <p className="font-body text-gray-500 text-xs leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
